import React from 'react';
import { FaEnvelopeOpenText } from 'react-icons/fa';
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import './mail_marketing.css';

const MailMarketing = () => {
  return (
    <div className="mail_marketing_page">
      <SharedHeader />
      
      <div className="mail_marketing_container">
        <header className="mail_marketing_header">
          <div className="mail_marketing_header_icon">
            <FaEnvelopeOpenText />
          </div>
          <h1>Email Marketing</h1>
          <p>Create and manage your email campaigns</p>
        </header>

        {/* Under Construction Notice */}
        <UnderConstruction pageName="Email Marketing" />
      </div>

      <DashboardFooter />
    </div>
  );
};

export default MailMarketing;
